module.exports = __webpack_public_path__ + "static/media/HMT.bac2187b.png";